import React from "react";
import { HiLocationMarker } from "@react-icons/all-files/hi/HiLocationMarker";
import { HiBriefcase } from "@react-icons/all-files/hi/HiBriefcase";
import { HiCurrencyDollar } from "@react-icons/all-files/hi/HiCurrencyDollar";
import { HiCalendar } from "@react-icons/all-files/hi/HiCalendar";
import { HiOutlineClipboardCheck } from "@react-icons/all-files/hi/HiOutlineClipboardCheck";
import { HiOutlineExclamationCircle } from "@react-icons/all-files/hi/HiOutlineExclamationCircle";
import { EMPLOYMENT_TYPES_BY_ID } from "../../../config/job-constants";

export default ({
  job,
  colorHighlightText,
  colorHighlightIcon,
  backgroundColor
}) => {
  return (
    <ul
      className="space-y-1 xl:space-y-2 mb-4 md:mb-2 p-2 md:p-5"
      style={{ backgroundColor: backgroundColor }}
    >
      {job.location_description && (
        <li className="flex items-center space-x-2 md:space-x-3">
          <div className="flex-shrink-0 self-center">
            <HiLocationMarker
              className="inline-block w-4 h-4 xl:h-6 xl:w-6"
              style={{ color: colorHighlightIcon }}
            />
          </div>
          <div
            className="md:text-body-text xl:text-lg self-center flex gap-x-1"
            style={{ color: colorHighlightText }}
          >
            {job.location_description ? (
              <div>{job.location_description}</div>
            ) : (
              ""
            )}
            {job.remote_work ? <div>({job.remote_work})</div> : ""}
          </div>
        </li>
      )}
      {job.employment_status_label && (
        <li className="flex items-center space-x-2 md:space-x-3">
          <div className="flex-shrink-0">
            <HiOutlineClipboardCheck
              className="inline-block w-4 h-4 xl:h-6 xl:w-6"
              style={{ color: colorHighlightIcon }}
            />
          </div>
          <div
            className="md:text-body-text xl:text-lg self-center"
            style={{ color: colorHighlightText }}
          >
            {job.employment_type && (
              <>{EMPLOYMENT_TYPES_BY_ID[job.employment_type]}</>
            )}{" "}
            {job.employment_status_label}
          </div>
        </li>
      )}
      {job.job_level_name && (
        <li className="flex items-center space-x-2 md:space-x-3">
          <div className="flex-shrink-0">
            <HiBriefcase
              className="inline-block w-4 h-4 xl:h-6 xl:w-6"
              style={{ color: colorHighlightIcon }}
            />
          </div>
          <div
            className="md:text-body-text xl:text-lg self-center"
            style={{ color: colorHighlightText }}
          >
            {job.job_level_name}
          </div>
        </li>
      )}
      {job.compensation_description && (
        <li className="flex items-center space-x-2 md:space-x-3">
          <HiCurrencyDollar
            className="inline-block w-4 h-4 xl:h-6 xl:w-6"
            style={{ color: colorHighlightIcon }}
          />

          <div
            className="md:text-body-text xl:text-lg"
            style={{ color: colorHighlightText }}
          >
            {job.compensation_description}
          </div>
        </li>
      )}

      {job["posted"] && (
        <li
          className="flex items-center space-x-2 md:space-x-3"
          style={{ color: colorHighlightText }}
        >
          <HiCalendar
            className="w-4 h-4 xl:h-6 xl:w-6 shrink-0"
            style={{ color: colorHighlightIcon }}
          />
          <div
            className="md:text-body-text xl:text-lg grow"
            style={{ color: colorHighlightText }}
          >
            Posted on {job["posted_formatted"]}
          </div>
        </li>
      )}
      {job["application_deadline"] && (
        <li
          className="flex items-center space-x-2 md:space-x-3"
          style={{ color: colorHighlightText }}
        >
          <HiOutlineExclamationCircle
            className="w-4 h-4 xl:h-6 xl:w-6 shrink-0"
            style={{ color: colorHighlightIcon }}
          />
          <div
            className="md:text-body-text xl:text-lg grow font-semibold"
            style={{ color: colorHighlightText }}
          >
            Apply by {job["application_deadline_formatted"]}
          </div>
        </li>
      )}
    </ul>
  );
};
